import { ObjectValues } from "types";

const QuestionInputType = {
  Radio: "radio",
  Checkbox: "checkbox",
  Matrix: "matrix",
} as const;

export type QuestionInputTypeTerm = ObjectValues<typeof QuestionInputType>;

export default QuestionInputType;
